const SET_STATE = 'personalInfoReducer/SET_STATE'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setPersonalInfoState = (stateValues) => ({
  type: SET_STATE,
  payload: stateValues,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const personalInfoReducer = (state, action) => {
  if (action.type === SET_STATE) {
    return {
      ...state,
      ...action.payload,
    }
  }

  return state
}
